<template>
  <div>
    <ul v-if="list.length" class="container">
      <li v-for="(item, index) in list" :key="index" class="item">
        <iain-image-domain v-if="item.img" w="100%" h="300" r="10" :src="item.img" />

        <div class="item-footer">
          <div class="item-title">{{ item.title }}</div>
          <div class="item-time">{{ item.createDate }}</div>
        </div>
      </li>
    </ul>

    <van-empty v-else class="custom mini" description="暂无直播动态" />
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px 30px 0;

  .item {
    padding-bottom: 15px;

    .item-footer {
      display: flex;
      justify-content: space-between;
      padding: 15px 0;

      .item-title {
        width: 580px;
        color: #222222;
      }

      .item-time {
        padding-left: 10px;
        flex-shrink: 0;
        color: #999999;
      }
    }
  }
}
</style>